<div class="container-group">
  <div class="dialog-form-header">
    <h2 mat-dialog-title>
      <ng-container *ngIf="!isEdit">Add Trip</ng-container>
      <ng-container *ngIf="isEdit"
        >Edit Schedule: Trip {{ tripData.tripId }}</ng-container
      >
    </h2>
    <!-- <button
      class="delete-schedule"
      mat-stroked-button
      type="button"
      color="warn"
      *ngIf="isEdit"
      (click)="onDeleteTimetable(false)">
      Delete Trip
    </button> -->
  </div>

  <mat-dialog-content class="dialog-content custom-page-scroll">
    <form class="" #editForm="ngForm" novalidate>
      <div class="trip-header-info">
        <div>
          <b>Route ID: </b><span>{{ routeId }}</span>
        </div>
        <div>
          <b>Trip Direction: </b><span>{{ tripDirection }}</span>
        </div>
        <div>
          <b>Route Pattern: </b><span>{{ routePattern }}</span>
        </div>
      </div>
      <div class="trip-header">
        <div class="trip-form main">
          <div class="form-text">
            Assigned {{ project === 'EARADAT' ? 'Driver' : 'Block' }}:
          </div>
          <div class="select-field">
            <mat-form-field
              appearance="outline"
              style="width: 120px"
              subscriptSizing="dynamic"
              hideRequiredMarker
              floatLabel="always">
              <mat-label
                >{{ project === 'EARADAT' ? 'Driver' : 'Block' }} ID</mat-label
              >
              <mat-select
                name="block"
                required
                #blockSelect="ngModel"
                placeholder="
                  Select
                "
                [(ngModel)]="tripData.blockId">
                <mat-option
                  *ngFor="let block of blockIdList"
                  [value]="block.id"
                  matTooltipPosition="right"
                  [matTooltip]="block.name">
                  {{ block.id }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="blockSelect.invalid && blockSelect.touched"
                >Required</mat-error
              >
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              hideRequiredMarker
              subscriptSizing="dynamic"
              floatLabel="always"
              *ngIf="project === 'EARADAT' && tripData.blockId?.length > 0"
              class="block-id-name read-only">
              <mat-label>Name</mat-label>
              <input
                name="DriverName"
                matInput
                aria-label="Driver ID"
                [ngModel]="getBlockName(tripData.blockId)"
                readonly />
            </mat-form-field>
          </div>
        </div>
      </div>

      <div
        class="trip-schedule"
        [ngClass]="{
          'skip-trip': skipTrip
        }">
        <div class="schedule-header">
          <div class="center-cell"></div>
          <div class="center-cell">Stop ID</div>
          <div>Stop Name</div>
          <div class="center-cell">Time</div>
          <div class="center-cell" *ngIf="skipTrip">Skip</div>
        </div>
        <div
          class="schedule-row"
          *ngFor="let stop of tripData.stops; let i = index">
          <ng-container *ngIf="stop.stopSequence">
            <div class="center-cell">
              <div class="stop-sequence">{{ stop.stopSequence }}</div>
            </div>
            <div class="center-cell cell">{{ stop.stopId }}</div>
            <div class="stop-cell cell">{{ stop.multilineStop }}</div>
            <div class="center-cell cell">
              <!-- {{ stop.schArrTime }} -->
              <!-- <div class="timepicker">
                <ngx-timepicker-field
                  [format]="24"
                  [ngModel]="stop.schArrTime"
                  [defaultTime]="'5:00'"
                  [clockTheme]="timePickerTheme"></ngx-timepicker-field>
              </div> -->
              <mat-form-field
                appearance="outline"
                subscriptSizing="dynamic"
                hideRequiredMarker
                class="time-field"
                floatLabel="always">
                <input
                  matInput
                  [disabled]="stop.skip"
                  name="selected_time_{{ i }}"
                  format="24"
                  [disableClick]="true"
                  [required]="!stop.skip"
                  #tripTime="ngModel"
                  [(ngModel)]="stop.schArrTime"
                  [ngxMatTimepicker]="pickerB" />
                <button
                  matSuffix
                  mat-icon-button
                  (click)="pickerB.open()"
                  [color]="tripTime.invalid && tripTime.touched ? 'warn' : ''"
                  [disabled]="stop.skip">
                  <mat-icon>watch_later</mat-icon>
                </button>
                <mat-error *ngIf="tripTime.invalid && tripTime.touched"
                  >Required</mat-error
                >
              </mat-form-field>
              <ngx-mat-timepicker
                #pickerB
                [disableClick]="true"></ngx-mat-timepicker>
              <!-- <ngx-mat-timepicker-field
                [ngModel]="stop.schArrTime"
                [disableClick]="true"
                [format]="24"></ngx-mat-timepicker-field> -->
              <!-- <ngx-mat-timepicker
                [(value)]="stop.schArrTime"
                [format]="24"
                [disableClick]="true">
              </ngx-mat-timepicker> -->
            </div>
            <div class="center-cell cell" *ngIf="skipTrip">
              <mat-checkbox
                [(ngModel)]="stop.skip"
                name="skip_{{ i }}"></mat-checkbox>
            </div>
          </ng-container>
        </div>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-stroked-button mat-dialog-close [disabled]="isProcessing">
      Cancel
    </button>
    <button
      mat-raised-button
      color="primary"
      type="button"
      (click)="onEdit()"
      [disabled]="isProcessing">
      Save
    </button>
  </mat-dialog-actions>
</div>
